import { AdaptiveFilterButtons } from '@/features/adaptiveFilterButtons/AdaptiveFilterButtons'

import { teamleadColumns } from '@/features/referrals/table/teamleadColumns'
import { teamleadsColumns } from '@/features/referrals/table/teamleadsColumns'
import { FilterButtonModel } from '@/shared/components/MobileFilterButtons/MobileFilterButtons'
import { SearchInput } from '@/shared/components/SearchInput/SearchInput'
import { useIsMobile } from '@/shared/utils'
import { teamleadsData } from '../../../table'
import { BaseTable } from 'syncra-storybook/features'

type Props = {
  selectedIndex: number
  selectFilterBtn: (index: number) => void
  setQuery: (value: string) => void
}

export const TeamleadsTable = ({ setQuery, selectFilterBtn, selectedIndex }: Props) => {
  const isMobile = useIsMobile()
  const tradersFilterButtons: FilterButtonModel[] = [
    { name: 'Все', label: 'all', index: 0 },
    { name: 'Активные', label: 'active', index: 1 },
    { name: 'Неактивные', label: 'disabled', index: 2 },
    { name: 'Не верифицированные', label: 'unverified', index: 3 },
    { name: 'Заблокированные', label: 'blocked', index: 4 },
  ]
  return (
    <>
      <div className="flex gap-2 mb-6">
        <AdaptiveFilterButtons
          filterButtons={tradersFilterButtons}
          selectedBtn={selectedIndex}
          setSelectedBtn={selectFilterBtn}
          minWidthMobile="150px"
          className="flex-1 md:mb-[40px]"
        />
        {isMobile && (
          <SearchInput onChange={(event) => setQuery(event.target.value)} className="flex-1" />
        )}
      </div>

      <BaseTable
        columns={teamleadsColumns}
        data={[]}
        totalItems={1}
        cardClasses="border-0"
        isRowLink
        // mobileCards={teamleadsData.map((teamlead) => (
        //   <ReferralMobileBlock key={teamlead.id} referral={teamlead} />
        // ))}
        expandableRows
        expandableChildren={() => (
          <BaseTable columns={teamleadColumns} data={teamleadsData} cardPadding="sm" />
        )}
      />
    </>
  )
}
